/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Popup from '@/kenwood/configurator/components/Popup';

export const PopupContent = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Popup isOpen={isOpen}>
      <div className='ken-configurator__generic-popup'>
        <button
          className='ken-configurator__generic-popup-close'
          type='button'
          onClick={onClose}
        >
          <img
            className='ken-configurator__generic-popup-close-img'
            src={`${DLG.config.distResourcePath}/assets/images/kenwood/configurator/close.svg`}
            alt={t('configurator:configurator.alt.close')}
          />
        </button>
        <div className='ken-configurator__generic-popup-content'>
          <div
            className='ken-configurator__generic-popup-title'
            dangerouslySetInnerHTML={{
              __html: t('configurator:configurator.promobanner.popup.title'),
            }}
          />
          <div
            className='ken-configurator__generic-popup-desc'
            dangerouslySetInnerHTML={{
              __html: t(
                'configurator:configurator.promobanner.popup.description',
              ),
            }}
          />
        </div>
      </div>
    </Popup>
  );
};

const BannerContent = ({ onOpen, t }) => (
  <div className='ken-configurator__promo-banner'>
    <div className='ken-configurator__promo-banner-content'>
      {t('configurator:configurator.promobanner.banner.pretitle') !== '' && (
        <div
          className='ken-configurator__promo-banner-pretitle'
          dangerouslySetInnerHTML={{
            __html: t('configurator:configurator.promobanner.banner.pretitle'),
          }}
        />
      )}
      {t('configurator:configurator.promobanner.banner.title') !== '' && (
        <div
          className='ken-configurator__promo-banner-title'
          dangerouslySetInnerHTML={{
            __html: t('configurator:configurator.promobanner.banner.title'),
          }}
        />
      )}
      <div
        className='ken-configurator__promo-banner-desc'
        dangerouslySetInnerHTML={{
          __html: t('configurator:configurator.promobanner.banner.description'),
        }}
      />
      <button
        className='ken-configurator__promo-banner-cta'
        type='button'
        onClick={onOpen}
      >
        {t('configurator:configurator.promobanner.banner.button.label')}
      </button>
    </div>
  </div>
);

const PromoBanner = () => {
  const [promoPopupOpen, setPromoPopupOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <BannerContent
        onOpen={() => {
          setPromoPopupOpen(true);
        }}
        t={t}
      />
      <PopupContent
        isOpen={promoPopupOpen}
        onClose={() => {
          setPromoPopupOpen(false);
        }}
      />
    </>
  );
};

PopupContent.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

BannerContent.propTypes = {
  onOpen: PropTypes.func,
  t: PropTypes.func,
};

BannerContent.defaultProps = {
  onOpen: () => {},
  t: () => {},
};

export default PromoBanner;
